import React from 'react';
import { connect } from 'react-redux';
import RemoveDatasetCollectionDialog from './RemoveDatasetCollectionDialog';
import AssignDatasetCollectionsDialog from './AssignDatasetCollectionsDialog';

const DatasetCollectionDialogs = ({ allowManage, allowRemove, theme }) => (
  <>
    {allowManage && (<AssignDatasetCollectionsDialog theme={theme} />)}
    {allowRemove && (<RemoveDatasetCollectionDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { update }, collections: { datasets } } } },
  datasetCollections: { collectionAssigningDataset, removeDatasetCollectionConfirmation },
}) => ({
  allowManage: collectionAssigningDataset.open && (datasets || update),
  allowRemove: removeDatasetCollectionConfirmation.open && (datasets || update),
});

export default connect(mapStateToProps)(DatasetCollectionDialogs);
